export const otherGroup = "OTHER";
